/* =========================================================
   Hydrizm LP – 液体モーフ（スクロール連動）
   プロトタイプ Hydrizm_liquid_morph_prototype.html を
   Shopifyセクション用に移植したもの。
   - 幅は固定390pxではなくコンテナ実寸に追従
   - 検証用スクラブUIは削除
   - 画面外ではrAFを止める（IntersectionObserver）
   - prefers-reduced-motion に対応
   ========================================================= */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.hzMorphReady === '1') return;
    root.dataset.hzMorphReady = '1';

    var track   = root.querySelector('[data-hz-track]');
    var sticky  = root.querySelector('[data-hz-sticky]');
    var lq      = root.querySelector('[data-hz-canvas]');
    var fx      = root.querySelector('[data-hz-fx]');
    var stepEls = Array.prototype.slice.call(root.querySelectorAll('[data-hz-step]'));
    if (!track || !sticky || !lq || !fx) return;

    var lc = lq.getContext('2d');
    var fc = fx.getContext('2d');

    var W = 390, H = 0, DPR = Math.min(2, window.devicePixelRatio || 1);

    /* カプセルの縦位置（画面高に対する割合）。水面はその15%下。 */
    var CAP_POS = parseFloat(track.dataset.hzCapsule);
    if (!isFinite(CAP_POS)) CAP_POS = 46;
    CAP_POS = Math.min(60, Math.max(30, CAP_POS)) / 100;

    /* ---------- 配色 ---------- */
    var CAP_RGB  = [232, 239, 243];   // カプセル：ほぼ透明
    var DROP_RGB = [198, 221, 240];   // 一滴：明るいブルー
    function mix(t) {
      return 'rgb(' +
        Math.round(CAP_RGB[0] + (DROP_RGB[0] - CAP_RGB[0]) * t) + ',' +
        Math.round(CAP_RGB[1] + (DROP_RGB[1] - CAP_RGB[1]) * t) + ',' +
        Math.round(CAP_RGB[2] + (DROP_RGB[2] - CAP_RGB[2]) * t) + ')';
    }
    var POWDER = 'rgba(150,167,178,';

    function resize() {
      var rect = sticky.getBoundingClientRect();
      W = Math.max(1, Math.round(rect.width));
      H = Math.max(1, Math.round(rect.height));
      DPR = Math.min(2, window.devicePixelRatio || 1);
      [lq, fx].forEach(function (c) {
        c.width = W * DPR;
        c.height = H * DPR;
        c.style.width = W + 'px';
        c.style.height = H + 'px';
      });
      lc.setTransform(DPR, 0, 0, DPR, 0, 0);
      fc.setTransform(DPR, 0, 0, DPR, 0, 0);
    }

    /* ---------- 補助 ---------- */
    function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }
    function lerp(a, b, t) { return a + (b - a) * t; }
    function seg(p, s, e) { return clamp((p - s) / (e - s), 0, 1); }
    function easeInOut(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
    function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
    function easeIn(t) { return t * t * t; }

    /* ---------- 粉末粒子（固定シード） ---------- */
    var powder = [];
    (function () {
      var s = 12345;
      function rnd() { s = (s * 16807) % 2147483647; return s / 2147483647; }
      for (var i = 0; i < 34; i++) {
        powder.push({
          a: rnd() * Math.PI * 2,
          d: 0.25 + rnd() * 0.75,
          r: 0.7 + rnd() * 1.5,
          sp: 0.6 + rnd() * 0.9,
          ph: rnd() * 6.28
        });
      }
    })();

    /* 冒頭を圧縮し、水滴として見えている区間を長めに配分する */
    function remap(v) {
      if (v <= 0.075) return v * 2;
      if (v <= 0.28)  return 0.1500 + (v - 0.075) * (0.1367 / 0.205);
      if (v <= 0.365) return 0.2867 + (v - 0.280) * (0.1633 / 0.085);
      if (v <= 0.62)  return 0.4500 + (v - 0.365) * (0.1700 / 0.255);
      return v;
    }

    /* ---------- ステップテキスト ---------- */
    var stepState = [false, false, false];
    function setStep(i, on) {
      if (stepState[i] === on || !stepEls[i]) return;
      stepState[i] = on;
      stepEls[i].classList.toggle('is-on', on);
    }

    /* ---------- 描画 ---------- */
    function draw(p, tms) {
      var raw = p;
      p = remap(p);
      var CX = W / 2;
      var TOP  = H * CAP_POS;          // カプセルの位置
      var SURF = H * (CAP_POS + 0.15);  // 水面

      lc.clearRect(0, 0, W, H);
      fc.clearRect(0, 0, W, H);

      var pDis  = seg(p, 0.10, 0.36);
      var pGath = seg(p, 0.30, 0.56);
      var pSet  = seg(p, 0.50, 0.62);
      var pNeck = seg(p, 0.58, 0.70);
      var pFall = seg(p, 0.62, 0.845);
      var pHit  = seg(p, 0.845, 0.872);
      var pRip  = seg(p, 0.850, 1.00);

      /* ===== 1. カプセル → 液体 ===== */
      var capAlpha = 1 - easeInOut(seg(p, 0.30, 0.46));
      var N = 15;
      var capH = 60, capR = 15.5;

      if (capAlpha > 0.01) {
        lc.save();
        lc.globalAlpha = capAlpha;
        lc.fillStyle = mix(easeInOut(pGath));
        var loosen = easeInOut(pDis);
        for (var i = 0; i < N; i++) {
          var u = i / (N - 1);
          var y0 = TOP - capH / 2 + capH * u;
          var w = clamp((u - (1 - loosen * 1.35)) * 2.2, 0, 1);
          var sag = w * 22 * easeIn(loosen);
          var wob = Math.sin(tms / 900 + i * 0.7) * 1.2 * loosen;
          var rr  = capR * (1 - w * 0.30) + w * 2.5;
          var xx  = CX + wob + Math.sin(i * 2.3) * 1.6 * w;
          var g = easeInOut(pGath);
          var ty = lerp(y0 + sag, TOP + 16, g);
          var tx = lerp(xx, CX, g);
          var tr = lerp(rr, 3 + 8 * (1 - u), g);
          lc.beginPath();
          lc.arc(tx, ty, Math.max(0.5, tr), 0, Math.PI * 2);
          lc.fill();
        }
        lc.restore();
      }

      /* ===== 1b. カプセルの陰影 ===== */
      var shadeA = capAlpha * (1 - easeInOut(pDis) * 1.15);
      if (shadeA > 0.02) {
        var EXP = 4.2;
        var cR = capR + EXP;
        var pw = cR * 2, ph = capH + capR * 2 + EXP * 2;
        var L = CX - cR, R = CX + cR;
        var TP = TOP - ph / 2, BT = TOP + ph / 2;

        fc.save();
        fc.globalAlpha = clamp(shadeA, 0, 1);

        fc.beginPath();
        fc.moveTo(L, TP + cR);
        fc.arcTo(L, TP, CX, TP, cR);
        fc.arcTo(R, TP, R, TP + cR, cR);
        fc.lineTo(R, BT - cR);
        fc.arcTo(R, BT, CX, BT, cR);
        fc.arcTo(L, BT, L, BT - cR, cR);
        fc.closePath();
        fc.clip();

        var gc = fc.createLinearGradient(L, 0, R, 0);
        gc.addColorStop(0.00, 'rgba(118,139,153,0.30)');
        gc.addColorStop(0.16, 'rgba(118,139,153,0.06)');
        gc.addColorStop(0.44, 'rgba(118,139,153,0.00)');
        gc.addColorStop(0.72, 'rgba(118,139,153,0.07)');
        gc.addColorStop(1.00, 'rgba(118,139,153,0.34)');
        fc.fillStyle = gc;
        fc.fillRect(L, TP, pw, ph);

        var gv = fc.createLinearGradient(0, TP, 0, BT);
        gv.addColorStop(0.00, 'rgba(118,139,153,0.16)');
        gv.addColorStop(0.14, 'rgba(118,139,153,0.00)');
        gv.addColorStop(0.86, 'rgba(118,139,153,0.00)');
        gv.addColorStop(1.00, 'rgba(118,139,153,0.20)');
        fc.fillStyle = gv;
        fc.fillRect(L, TP, pw, ph);

        var gh = fc.createLinearGradient(L + pw * 0.20, 0, L + pw * 0.52, 0);
        gh.addColorStop(0.00, 'rgba(255,255,255,0)');
        gh.addColorStop(0.45, 'rgba(255,255,255,0.85)');
        gh.addColorStop(1.00, 'rgba(255,255,255,0)');
        fc.fillStyle = gh;
        fc.fillRect(L + pw * 0.20, TP + cR * 0.55, pw * 0.32, ph - cR * 1.1);

        fc.beginPath();
        fc.moveTo(L + 1, TOP);
        fc.lineTo(R - 1, TOP);
        fc.strokeStyle = 'rgba(118,139,153,0.22)';
        fc.lineWidth = 1;
        fc.stroke();

        fc.restore();
      }

      /* ===== 2. 粉末 ===== */
      var powA = Math.sin(Math.PI * seg(p, 0.16, 0.44));
      if (powA > 0.01) {
        fc.save();
        for (var k = 0; k < powder.length; k++) {
          var q = powder[k];
          var spread = 44 * easeOut(seg(p, 0.16, 0.40)) * q.d;
          var px = CX + Math.cos(q.a) * spread + Math.sin(tms / 1400 + q.ph) * 3;
          var py = TOP + Math.sin(q.a) * spread * 0.9 + q.sp * 20 * easeIn(seg(p, 0.20, 0.44));
          fc.beginPath();
          fc.arc(px, py, q.r, 0, Math.PI * 2);
          fc.fillStyle = POWDER + (0.42 * powA) + ')';
          fc.fill();
        }
        fc.restore();
      }

      /* ===== 3. 一滴へ収束 → 表面張力 → 落下 ===== */
      var gatherA = easeInOut(seg(p, 0.34, 0.56));
      if (gatherA > 0.005) {
        var settle = 1 - easeOut(pSet);
        var wob1 = Math.sin(tms / 260) * 3.4 * settle;
        var wob2 = Math.sin(tms / 170 + 1.1) * 2.1 * settle;

        var fallY = pFall * pFall * (SURF - (TOP + 36));
        var hit   = easeOut(pHit);

        var dr = lerp(9, 22, gatherA);
        var cx = CX;
        var cy = TOP + 36 + fallY + hit * dr * 0.55;

        var osc  = Math.sin(pFall * Math.PI * 4.0) * (1 - pFall * 0.45) * 0.135;
        var strh = pFall * 0.07;
        var sx = 1 + wob1 * 0.02 + hit * 1.05 - osc - strh * 0.6;
        var sy = 1 - wob1 * 0.02 - hit * 0.78 + osc + strh;

        var bodyA = 1 - easeOut(seg(p, 0.852, 0.882));

        lc.save();
        lc.fillStyle = mix(gatherA);
        lc.globalAlpha = bodyA;

        /* くびれ */
        if (pNeck > 0 && pFall < 0.62) {
          var neckTop = TOP + 36;
          var neckLen = cy - neckTop;
          var pinch = easeInOut(pNeck);
          var steps = 7;
          for (var s = 1; s <= steps; s++) {
            var v = s / (steps + 1);
            var ny = neckTop + neckLen * v;
            var base = lerp(dr * 0.62, dr * 0.18, pinch);
            var nr = base * (1 - Math.pow(Math.abs(v - 0.5) * 2, 1.6) * 0.55);
            nr *= (1 - easeIn(seg(p, 0.66, 0.73)));
            if (nr <= 0.4) continue;
            lc.beginPath();
            lc.arc(cx + wob2 * (1 - v) * 0.5, ny, nr, 0, Math.PI * 2);
            lc.fill();
          }
          var restR = dr * 0.55 * (1 - easeIn(seg(p, 0.64, 0.76)));
          if (restR > 0.5) {
            lc.beginPath();
            lc.arc(cx, neckTop - 2, restR, 0, Math.PI * 2);
            lc.fill();
          }
        }

        /* 本体 */
        lc.save();
        lc.translate(cx + wob2 * 0.4, cy);
        lc.scale(sx, sy);
        lc.beginPath();
        lc.arc(0, 0, dr, 0, Math.PI * 2);
        lc.fill();
        if (pFall > 0.02 && pFall < 0.98) {
          var tail = (1 - easeOut(pFall)) * dr * 0.9;
          var tsc  = 1 + osc * 2.2;
          for (var tI = 1; tI <= 3; tI++) {
            var tv = tI / 4;
            lc.beginPath();
            lc.arc(0, -dr * tv * 1.28 * tsc, dr * (1 - tv) * 0.44 * (2 - tsc) + tail * 0.08, 0, Math.PI * 2);
            lc.fill();
          }
        }
        lc.restore();
        lc.restore();

        /* 水滴の質感 */
        var hlA = bodyA * gatherA;
        if (hlA > 0.01) {
          fc.save();
          fc.translate(cx + wob2 * 0.4, cy);
          fc.scale(sx, sy);
          fc.globalAlpha = hlA;

          if (pFall > 0.02 && pFall < 0.98) {
            var gTail = fc.createRadialGradient(0, -dr * 0.52, dr * 0.04, 0, -dr * 0.52, dr * 0.92);
            gTail.addColorStop(0.00, 'rgba(86,128,170,0.14)');
            gTail.addColorStop(0.55, 'rgba(86,128,170,0.07)');
            gTail.addColorStop(1.00, 'rgba(86,128,170,0)');
            fc.beginPath();
            fc.ellipse(0, -dr * 0.52, dr * 0.50, dr * 0.92, 0, 0, Math.PI * 2);
            fc.fillStyle = gTail;
            fc.fill();

            var gTl = fc.createLinearGradient(-dr * 0.26, 0, dr * 0.02, 0);
            gTl.addColorStop(0.00, 'rgba(255,255,255,0)');
            gTl.addColorStop(0.55, 'rgba(255,255,255,0.55)');
            gTl.addColorStop(1.00, 'rgba(255,255,255,0)');
            fc.beginPath();
            fc.ellipse(-dr * 0.13, -dr * 0.55, dr * 0.13, dr * 0.42, 0, 0, Math.PI * 2);
            fc.fillStyle = gTl;
            fc.fill();
          }

          var gRim = fc.createRadialGradient(0, 0, dr * 0.28, 0, 0, dr);
          gRim.addColorStop(0.00, 'rgba(86,128,170,0)');
          gRim.addColorStop(0.56, 'rgba(86,128,170,0.03)');
          gRim.addColorStop(0.80, 'rgba(86,128,170,0.17)');
          gRim.addColorStop(0.95, 'rgba(74,118,164,0.40)');
          gRim.addColorStop(1.00, 'rgba(74,118,164,0.16)');
          fc.beginPath();
          fc.arc(0, 0, dr, 0, Math.PI * 2);
          fc.fillStyle = gRim;
          fc.fill();

          var gTop = fc.createLinearGradient(0, -dr, 0, dr * 0.25);
          gTop.addColorStop(0.00, 'rgba(86,128,170,0.18)');
          gTop.addColorStop(1.00, 'rgba(86,128,170,0)');
          fc.beginPath();
          fc.arc(0, 0, dr * 0.98, 0, Math.PI * 2);
          fc.fillStyle = gTop;
          fc.fill();

          fc.save();
          fc.beginPath();
          fc.arc(0, 0, dr * 0.97, 0, Math.PI * 2);
          fc.clip();
          var gCau = fc.createRadialGradient(0, dr * 0.40, 0, 0, dr * 0.40, dr * 0.80);
          gCau.addColorStop(0.00, 'rgba(255,255,255,1)');
          gCau.addColorStop(0.42, 'rgba(255,255,255,0.78)');
          gCau.addColorStop(1.00, 'rgba(255,255,255,0)');
          fc.beginPath();
          fc.ellipse(0, dr * 0.38, dr * 0.76, dr * 0.52, 0, 0, Math.PI * 2);
          fc.fillStyle = gCau;
          fc.fill();
          fc.restore();

          fc.beginPath();
          fc.ellipse(-dr * 0.34, -dr * 0.41, dr * 0.21, dr * 0.13, -0.55, 0, Math.PI * 2);
          fc.fillStyle = 'rgba(255,255,255,0.98)';
          fc.fill();

          fc.beginPath();
          fc.ellipse(dr * 0.28, -dr * 0.14, dr * 0.075, dr * 0.05, 0.4, 0, Math.PI * 2);
          fc.fillStyle = 'rgba(255,255,255,0.7)';
          fc.fill();

          fc.restore();
        }
      }

      /* ===== 4. 波紋 ===== */
      if (pRip > 0) {
        fc.save();

        var sm = 1 - easeOut(seg(p, 0.850, 0.99));
        if (sm > 0.01) {
          fc.save();
          fc.translate(CX, SURF); fc.scale(1, 0.26); fc.translate(-CX, -SURF);

          var g1 = fc.createRadialGradient(CX, SURF, 4, CX, SURF, 78);
          g1.addColorStop(0.00, 'rgba(92,132,172,' + (0.22 * sm) + ')');
          g1.addColorStop(0.55, 'rgba(92,132,172,' + (0.11 * sm) + ')');
          g1.addColorStop(1.00, 'rgba(92,132,172,0)');
          fc.beginPath(); fc.arc(CX, SURF, 78, 0, Math.PI * 2);
          fc.fillStyle = g1; fc.fill();

          var g2 = fc.createRadialGradient(CX, SURF, 0, CX, SURF, 46);
          g2.addColorStop(0.00, 'rgba(255,255,255,' + (0.92 * sm) + ')');
          g2.addColorStop(0.70, 'rgba(255,255,255,' + (0.35 * sm) + ')');
          g2.addColorStop(1.00, 'rgba(255,255,255,0)');
          fc.beginPath(); fc.arc(CX, SURF, 46, 0, Math.PI * 2);
          fc.fillStyle = g2; fc.fill();

          fc.restore();
        }

        for (var r = 0; r < 4; r++) {
          var delay = r * 0.12;
          var rp = clamp((pRip - delay) / (1 - delay), 0, 1);
          if (rp <= 0) continue;
          var e = easeOut(rp);
          var rx = 12 + e * (W * 0.43);
          var ry = rx * 0.23;
          var a = (1 - e) * 0.34;
          if (a <= 0.004) continue;

          var gs = fc.createLinearGradient(CX - rx, 0, CX + rx, 0);
          gs.addColorStop(0.00, 'rgba(92,132,172,0)');
          gs.addColorStop(0.17, 'rgba(92,132,172,' + a + ')');
          gs.addColorStop(0.42, 'rgba(92,132,172,' + (a * 0.10) + ')');
          gs.addColorStop(0.58, 'rgba(92,132,172,' + (a * 0.10) + ')');
          gs.addColorStop(0.83, 'rgba(92,132,172,' + a + ')');
          gs.addColorStop(1.00, 'rgba(92,132,172,0)');

          fc.beginPath();
          fc.ellipse(CX, SURF, rx, ry, 0, 0, Math.PI * 2);
          fc.strokeStyle = gs;
          fc.lineWidth = 1.7 - r * 0.22;
          fc.stroke();

          var gw = fc.createLinearGradient(CX - rx, 0, CX + rx, 0);
          var aw = a * 1.35;
          gw.addColorStop(0.00, 'rgba(255,255,255,0)');
          gw.addColorStop(0.22, 'rgba(255,255,255,' + aw + ')');
          gw.addColorStop(0.50, 'rgba(255,255,255,0)');
          gw.addColorStop(0.78, 'rgba(255,255,255,' + aw + ')');
          gw.addColorStop(1.00, 'rgba(255,255,255,0)');

          fc.beginPath();
          fc.ellipse(CX, SURF - 1.6, rx * 0.975, ry * 0.965, 0, 0, Math.PI * 2);
          fc.strokeStyle = gw;
          fc.lineWidth = 2.0;
          fc.stroke();
        }
        fc.restore();
      }

      /* ===== ステップテキスト（スクロール実値で制御） ===== */
      setStep(0, raw > 0.10 && raw < 0.325);
      setStep(1, raw > 0.385 && raw < 0.625);
      setStep(2, raw > 0.700);
    }

    /* ---------- スクロール進行 ---------- */
    function scrollP() {
      var r = track.getBoundingClientRect();
      var total = track.offsetHeight - sticky.offsetHeight;
      if (total <= 0) return 0;
      return clamp(-r.top / total, 0, 1);
    }

    var reduce = window.matchMedia &&
                 window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var sp = 0;
    var running = false;
    var rafId = null;

    function loop(now) {
      var target = scrollP();
      if (reduce) {
        sp = target;
        draw(sp, 0);
      } else {
        sp += (target - sp) * 0.10;
        draw(sp, now);
      }
      if (running) rafId = requestAnimationFrame(loop);
    }

    function start() {
      if (running) return;
      running = true;
      rafId = requestAnimationFrame(loop);
    }
    function stop() {
      running = false;
      if (rafId) cancelAnimationFrame(rafId);
      rafId = null;
    }

    resize();
    draw(0, 0);

    var ro = null;
    if (window.ResizeObserver) {
      ro = new ResizeObserver(function () { resize(); draw(sp, 0); });
      ro.observe(sticky);
    } else {
      window.addEventListener('resize', function () { resize(); draw(sp, 0); });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { en.isIntersecting ? start() : stop(); });
      }, { rootMargin: '10% 0px' });
      io.observe(track);
    } else {
      start();
    }

    /* テーマエディタで再描画されたときの後始末 */
    document.addEventListener('shopify:section:unload', function (e) {
      if (e.target && e.target.contains(root)) {
        stop();
        if (ro) ro.disconnect();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-hz-morph]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
